// import Image from 'next/image';
import parse from 'html-react-parser';
import { socialCardKeys } from '@/src/constants/socialcard.constant'
import dayjs from 'dayjs';

import { textColors, cardColors } from '@/src/constants/wall.constant';
import ClassNames from 'src/components/componentHelper/ClassNames';

import ReadMoreReadLess from 'src/components/componentHelper/ReadMoreReadLess'

const CleanPictureCard = ({ cardWidth, cardItem, fontStyle, darkModeEnabled, cardFontColor, cardBackgroundObject, ratingColor, quotationColor, darkCardTheme, linkColor, engagementDisabled, smallSize, refresh, shortenText, isDateTimeDisabled }) => {


    return (
        <div className="mx-auto py-3" style={{maxWidth: "40rem",minWidth:cardWidth}}>
      
    
      <div 
      className="flex flex-col-reverse justify-between w-full p-10 relative border" 
      style={
        {...(cardBackgroundObject?cardBackgroundObject:{}),borderRadius:'0.75rem',maxWidth:'640px',boxShadow:'5px 10px 5px -3px rgb(0 0 0 / 10%), 0px 4px 46px -2px rgb(0 0 0 / 5%)'}
    }
      
      >
        <div className='absolute' style={{top:'-10px', left: '35px', backgroundSize:'cover'}}>
        <svg
  xmlns="http://www.w3.org/2000/svg"
  width={26}
  height={21}
  viewBox="0 0 29 21"
  fill="none"
>
  <path
    d="M6.91391 21C4.56659 21 2.81678 20.2152 1.66446 18.6455C0.55482 17.0758 0 15.2515 0 13.1727C0 11.2636 0.405445 9.43939 1.21634 7.7C2.0699 5.91818 3.15821 4.3697 4.48124 3.05454C5.84695 1.69697 7.31935 0.678787 8.89845 0L13.3157 3.24545C11.5659 3.96667 9.98676 4.94242 8.57837 6.17273C7.21266 7.36061 6.25239 8.63333 5.69757 9.99091L6.01766 10.1818C6.27373 10.0121 6.55114 9.88485 6.84989 9.8C7.19132 9.71515 7.63944 9.67273 8.19426 9.67273C9.34658 9.67273 10.4776 10.097 11.5872 10.9455C12.7395 11.7939 13.3157 13.1091 13.3157 14.8909C13.3157 16.8848 12.6542 18.4121 11.3311 19.4727C10.0508 20.4909 8.57837 21 6.91391 21ZM22.5982 21C20.2509 21 18.5011 20.2152 17.3488 18.6455C16.2391 17.0758 15.6843 15.2515 15.6843 13.1727C15.6843 11.2636 16.0898 9.43939 16.9007 7.7C17.7542 5.91818 18.8425 4.3697 20.1656 3.05454C21.5313 1.69697 23.0037 0.678787 24.5828 0L29 3.24545C27.2502 3.96667 25.6711 4.94242 24.2627 6.17273C22.897 7.36061 21.9367 8.63333 21.3819 9.99091L21.702 10.1818C21.9581 10.0121 22.2355 9.88485 22.5342 9.8C22.8756 9.71515 23.3238 9.67273 23.8786 9.67273C25.0309 9.67273 26.1619 10.097 27.2715 10.9455C28.4238 11.7939 29 13.1091 29 14.8909C29 16.8848 28.3385 18.4121 27.0155 19.4727C25.7351 20.4909 24.2627 21 22.5982 21Z"
    fill={quotationColor?quotationColor:"#7975f0"}

  />
</svg>


        </div>

        <div className='absolute' style={{top:'0px', right: '30px', backgroundSize:'cover'}}>

  

      </div>

  <div className="flex flex-col justify-between text-left" >
    <p  className={ClassNames("text-lg tweet-content",fontStyle && fontStyle!==''?`font-${fontStyle}`:'')} style={{ color: !darkModeEnabled ? (cardFontColor || textColors.black.primary) : (cardFontColor || textColors.light.primary), fontSize: !smallSize?"1.15em":"1.0em",lineHeight: !smallSize? 1.5: 1.7 }}>
    {cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!==''?
                  shortenText?
                        <ReadMoreReadLess elementId={cardItem[socialCardKeys.uuid]}  refresh={()=>refresh()} text={cardItem[socialCardKeys.messageContent]} parse={parse} length={300} readMore={"Read More"} readLess={"Read Less"}/>
                        :
                        parse(cardItem[socialCardKeys.messageContent])
                  :
                  null
               }
    </p>

    {
                  cardItem[socialCardKeys.screenshotImage] &&
                  <div className="flex justify-center w-full"  style={{width: '100%', position: 'relative'}}>

                      <img loading="lazy"  className="w-auto h-auto rounded-md " onLoad={()=>refresh()} priority={true} layout="fill" objectFit="contain" style={{ width: '100%', borderRadius: '8px', objectFit: 'contain' }} src={cardItem[socialCardKeys.screenshotImage]} alt="Picture" />

                  </div>
               }

    { (!isDateTimeDisabled && cardItem[socialCardKeys.messageTime]) ?
    <div className={ClassNames('mt-3',fontStyle && fontStyle!==''?`font-${fontStyle}`:'')} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.secondary), fontSize: 13 } : { color: (cardFontColor || textColors.light.secondary), fontSize: 13 }}>{dayjs(cardItem[socialCardKeys.messageTime]).locale('en').format('DD MMM YYYY')}</div>
    :
    null
    }


  </div>
</div>

</div>
    );
};

export default CleanPictureCard;

